import React from 'react';
import classnames from 'classnames';

import './tile.scss';

export interface Props {
  className?: string;
  onClick?: (event: React.SyntheticEvent<EventTarget>) => void;
  id?: string;
  children?: React.ReactNode;
}

const Tile: React.FC<Props> = props => {
  const classes = classnames('tile-component', props.className);
  return (
    <div role="none" onClick={props.onClick} id={props.id} className={classes}>
      {props.children}
    </div>
  );
};

export default Tile;
